import { simpleAction } from '../../utils';
import * as TYPES from './types';

/**
 * Request Products
 */
export const designsGetRequest = simpleAction(TYPES.DESIGNS_GET_REQUEST);

/**
 * Request designs success
 * @param payload
 */
export const designsGetSuccess = simpleAction(TYPES.DESIGNS_GET_SUCCESS);

/**
 * Request designs error
 */
export const designsGetError = simpleAction(TYPES.DESIGNS_GET_FAIL);

/**
 * Request Order
 */
export const designLoadRequest = simpleAction(TYPES.DESIGN_LOAD_REQUEST);

/**
 * Request Order success
 * @param payload
 */
export const designLoadSuccess = simpleAction(TYPES.DESIGN_LOAD_SUCCESS);

/**
 * Request Order error
 */
export const designLoadError = simpleAction(TYPES.DESIGN_LOAD_FAIL);

/**
 * Create Order
 */
export const designCreateRequest = simpleAction(TYPES.DESIGN_CREATE_REQUEST);

/**
 * Create Order Success
 * @param payload
 */
export const designCreateSuccess = simpleAction(TYPES.DESIGN_CREATE_SUCCESS);

/**
 * Create Order Error
 */
export const designCreateError = simpleAction(TYPES.DESIGN_CREATE_FAIL);

/**
 * Create Order Error
 */
export const designCreateDone = simpleAction(TYPES.DESIGN_CREATE_DONE);

/**
 * Update Order
 */
export const designUpdateRequest = simpleAction(TYPES.DESIGN_UPDATE_REQUEST);

/**
 * Update Order Success
 * @param payload
 */
export const designUpdateSuccess = simpleAction(TYPES.DESIGN_UPDATE_SUCCESS);

/**
 * Update Order Error
 */
export const designUpdateError = simpleAction(TYPES.DESIGN_UPDATE_FAIL);

/**
 * Update Order Error
 */
export const designUpdateDone = simpleAction(TYPES.DESIGN_UPDATE_DONE);

/**
 * Commit step state
 */
export const designRequestStepCommit = simpleAction(TYPES.DESIGN_REQUEST_STEP_COMMIT);

/**
 * Reset steps
 */
export const designRequestReset = simpleAction(TYPES.DESIGN_REQUEST_RESET);

// ### DESIGN EXAMPLES #########################################################################
/**
 * Request Products
 */
export const designExamplesGetRequest = simpleAction(TYPES.DESIGN_EXAMPLES_GET_REQUEST);

/**
 * Request designExamples success
 * @param payload
 */
export const designExamplesGetSuccess = simpleAction(TYPES.DESIGN_EXAMPLES_GET_SUCCESS);

/**
 * Request designExamples error
 */
export const designExamplesGetError = simpleAction(TYPES.DESIGN_EXAMPLES_GET_FAIL);

/**
 * Request Order
 */
export const designExampleLoadRequest = simpleAction(TYPES.DESIGN_EXAMPLE_LOAD_REQUEST);

/**
 * Request Order success
 * @param payload
 */
export const designExampleLoadSuccess = simpleAction(TYPES.DESIGN_EXAMPLE_LOAD_SUCCESS);

/**
 * Request Order error
 */
export const designExampleLoadError = simpleAction(TYPES.DESIGN_EXAMPLE_LOAD_FAIL);

/**
 * Create Order
 */
export const designExampleCreateRequest = simpleAction(TYPES.DESIGN_EXAMPLE_CREATE_REQUEST);

/**
 * Create Order Success
 * @param payload
 */
export const designExampleCreateSuccess = simpleAction(TYPES.DESIGN_EXAMPLE_CREATE_SUCCESS);

/**
 * Create Order Error
 */
export const designExampleCreateError = simpleAction(TYPES.DESIGN_EXAMPLE_CREATE_FAIL);

/**
 * Create Order Error
 */
export const designExampleCreateDone = simpleAction(TYPES.DESIGN_EXAMPLE_CREATE_DONE);

/**
 * Update Order
 */
export const designExampleUpdateRequest = simpleAction(TYPES.DESIGN_EXAMPLE_UPDATE_REQUEST);

/**
 * Update Order Success
 * @param payload
 */
export const designExampleUpdateSuccess = simpleAction(TYPES.DESIGN_EXAMPLE_UPDATE_SUCCESS);

/**
 * Update Order Error
 */
export const designExampleUpdateError = simpleAction(TYPES.DESIGN_EXAMPLE_UPDATE_FAIL);

/**
 * Update Order Error
 */
export const designExampleUpdateDone = simpleAction(TYPES.DESIGN_EXAMPLE_UPDATE_DONE);
